import { COMPONENTS as RetencionDeFondos } from './retencion-de-fondos.components.constant';
import { COMPONENTS as SuministroDeInformacion } from './suministro-de-informacion.components.constant';
import { COMPONENTS as InvestigacionAsuntosInternos } from './invetigacion-asuntos-internos.components.constant';
import { COMPONENTS as RecuperacionDeFondosCuentaExterna } from './recuperacion-de-fondos-de-cuenta-externa.components.constant';
import { COMPONENTS as AsuntosExternos } from './asuntosExternos.constant';
import { COMPONENTS as GestionDeFraudes } from './gestion-de-fraudes.constant';
import { COMPONENTS as Ras } from './ras';
import { COMPONENTS as Ldc } from './ldc';
import { COMPONENTS as CAICAE } from './tareas-internos-externos.constants';

export const COMPONENTS = [
  ...RetencionDeFondos,
  ...SuministroDeInformacion,
  ...InvestigacionAsuntosInternos,
  ...RecuperacionDeFondosCuentaExterna,
  ...AsuntosExternos,
  ...GestionDeFraudes,
  ...Ras,
  ...Ldc,
  ...CAICAE,
];
